/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConfigService } from "../../app-config/app-config.service";
import { ParticipantDTO } from "app/core/models/participant-dto";
import { EMPTY, expand, map, Observable, reduce } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  	providedIn: 'root'
})

export class HttpGetParticipantsService {

    public readonly URL: string;
	private readonly pageSize = 50;

	constructor(
		private http: HttpClient,
        private configSvc: AppConfigService
	) {
        this.URL = this.configSvc.settings.nodeUrl + 'participants';
    }

    public obtain$(): Observable<ParticipantDTO[]> {
		return this.obtainPage$(0).pipe(
			expand(({ participants, offset }) => participants.length === this.pageSize
				? this.obtainPage$(offset + this.pageSize)
				: EMPTY
			),
			map(({ participants }) => participants),
			reduce((allParticipants, participants) => [...allParticipants, ...participants], [] as ParticipantDTO[])
		);
    }

    private obtainPage$(offset: number): Observable<{ participants: ParticipantDTO[]; offset: number }> {

        const headers = new HttpHeaders({
			'x-api-key': this.configSvc.settings.participantsAPIKey,
			'Content-Type': 'application/json'
		});

		const params = new HttpParams()
			.set('offset', offset)
			.set('limit', this.pageSize);

		return this.http.get<ParticipantDTO[]>(
			this.URL,
			{ headers, params }
		).pipe(
			map(participants => ({ participants, offset }))
		);

    }

}